<template>
  <div>
    <h1 class="page-header">{{ $t('building.building') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
              class="kh-font"
            />
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="branch_name_en">
                  {{ row.branch !== null ? row.branch.branch_name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="address">
                  {{ $store.getters.limitStringShow(row.address) }}
                </template>
                <template slot-scope="{ row }" slot="bd_description">
                  {{ $store.getters.limitStringShow(row.bd_description) }}
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(row.building_id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'building',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      exporting: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('building', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.building.search
      },
      set (newVal) {
        this.$store.commit('building/SET_SEARCH', newVal)
        this.$store.commit('building/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('building.branch'),
          slot: 'branch_name_en',
          minWidth: 80
        },
        { title: this.$t('building.name'), key: 'building_name', minWidth: 80 },
        { title: this.$t('building.address'), slot: 'address', minWidth: 80 },
        {
          title: this.$t('building.description'),
          slot: 'bd_description',
          minWidth: 80
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('building/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit (data) {
      this.edit_data = data
      this.$router.push(`/buildings/${data.building_id}`)
    },

    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('building/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'building-create') {
      this.$store.commit('building/RESET_STATE')
    }
    next()
  }
}
</script>
